import type { GesCloudHandoffRefusalReason } from "@ext/enterprise-cloud/GesCloudApi";
import type { ComponentType } from "react";
import { OrganizationAccessDeniedModal } from "./OrganizationAccessDeniedModal";
import { SessionExpiredModal } from "./SessionExpiredModal";

interface RefusalModalProps {
	onClose: () => void;
}

const MODAL_BY_REFUSAL = {
	forbidden: OrganizationAccessDeniedModal,
	unauthorized: SessionExpiredModal,
} satisfies Record<GesCloudHandoffRefusalReason, ComponentType<RefusalModalProps>>;

export const isOrganizationSwitchRefusal = (result: string): result is GesCloudHandoffRefusalReason =>
	Object.hasOwn(MODAL_BY_REFUSAL, result);

interface OrganizationSwitchRefusalModalProps extends RefusalModalProps {
	reason: GesCloudHandoffRefusalReason;
}

export const OrganizationSwitchRefusalModal = ({ reason, onClose }: OrganizationSwitchRefusalModalProps) => {
	const Modal = MODAL_BY_REFUSAL[reason];
	return <Modal onClose={onClose} />;
};
